import { Iarea } from '@/types/Iarea';

export class clsEstimateData {
  qty: number;
  totalPrice: number;
  totalPriceIncTax: number;
  deadline: string;
  period: string;
  latlng: string;
  isWeek: number;
  adjArea: Iarea;
  summaryQty: { [key: string]: number };
  orderReady: boolean;
  constructor() {
    this.qty = 0;
    this.totalPrice = 0;
    this.totalPriceIncTax = 0;
    this.deadline = '';
    this.period = '';
    this.latlng = '';
    this.isWeek = 0;
    this.adjArea = {
      no: '',
      gst_name: '',
      text: '',
      key_code: '',
      qty: 0,
      uprice: 0,
      sch_col: ''
    }
    this.summaryQty = {};
    this.orderReady = false;
  }
}